export default {
  SET_SURVEY(state, surveys) {
    state.surveys = surveys
  },
  SET_SURVEY_COUNT(state, count) {
    state.surveysCount = count
  },
  REMOVE_RECORD(state, itemId) {
    const surveyIndex = state.surveys.findIndex(u => u.id === itemId)
    state.surveys.splice(surveyIndex, 1)
  }
}
